import { AnswerBlock } from '../../models/message';

/** A run of the answer as it is laid out. */
export type AnswerGroup = { kind: 'paragraph'; text: string } | { kind: 'heading'; text: string } | { kind: 'list'; items: AnswerBlock[] };

/** Consecutive text blocks form one paragraph, headings stand alone, consecutive items form one list. */
export function groupBlocks(blocks: AnswerBlock[]): AnswerGroup[] {
   const groups: AnswerGroup[] = [];
   blocks.forEach((block) => {
      const last = groups[groups.length - 1];
      if (block.kind === 'item') {
         if (last?.kind === 'list') last.items.push(block);
         else groups.push({ kind: 'list', items: [block] });
      } else if (block.kind === 'heading') {
         groups.push({ kind: 'heading', text: block.text });
      } else if (last?.kind === 'paragraph') {
         last.text = `${last.text} ${block.text}`;
      } else {
         groups.push({ kind: 'paragraph', text: block.text });
      }
   });
   return groups;
}

/** An item's text split around its value (its first occurrence, unless the item says where), so it can be shown in bold. */
export function splitAtValue(item: AnswerBlock): { before: string; value?: string; after: string } {
   const placed = item.value !== undefined && item.valueAt !== undefined && item.text.startsWith(item.value, item.valueAt);
   const at = !item.value ? -1 : placed ? item.valueAt! : item.text.indexOf(item.value);
   if (!item.value || at < 0) return { before: item.text, after: '' };
   return { before: item.text.slice(0, at), value: item.value, after: item.text.slice(at + item.value.length) };
}
